<template lang="pug">
Popup(
  v-if="shouldShowMobileCharge"
  :visible="showChargePopup"
  :position="'bottom'"
  :mask-closable="true"
  @close="handleClose")
  .charge-popup-container
    .charge-popup-header
      img.charge-popup-title(src="https://m.hellobike.com/cd8db1dca9.png")
      img.close-icon(src="https://m.hellobike.com/resource/gallery/61/__G7W1L7To.png" @click="handleClose")
    .charge-popup-content
      ColumnCarousel.marquee(:dataList="mobileCharge.chargeRecords" :autoplay="2000")
        template(v-slot="{ itemData }")
          HighlightText.marquee-text(
            :text="itemData"
            :normalStyle="normalMarqueeStyle"
            :highlightStyles="highlightMarqueeStyles")
      .coupon-container
        .left-charge-coupon(:class="{ 'isUsed': archiveMobileCoupon }")
          .left-charge-title 话费券
          .left-charge-price {{ mobileCoupon.amount }}
          .left-charge-rules {{mobileCoupon.subWord || ''}}
          img.left-charge-isUsed-icon(v-if="archiveMobileCoupon" src="https://m.hellobike.com/dff6c01f25.png")
        img.middle-plus-icon(src="https://m.hellobike.com/ef9fc2071d.png")
        .right-bonus-coupon
          .right-bonus-title 奖励金抵扣
          .right-bonus-price {{ mobileCharge.rewardDeduction}}
          .right-bonus-rules {{ mobileCharge.rewardDeductionText}}
          .bonusSum(v-if="mobileCharge.usedRewardDeduction > 0")
            .bonusSum-text {{bonusSumText}}
      .charge-popup-btn(@click="handleCharge") {{ chargeBtnText }}
      HighlightText.charge-desc-text(
        text="{获取奖励金}可前往「福利中心/奖励金」查看"
        :normalStyle="normalDescStyle"
        :highlightStyle="highlightDescStyle")
</template>

<script>
import { Popup, HighlightText } from '@hb/platformui-h5';
import ColumnCarousel from '@/components/Carousel/ColumnCarousel.vue';
import { safeGet } from '@/utils';
import { COUPON_STATUS } from '@/pages/vip/consts';
import { Navigator } from '@hb/h5-navigator';

export default {
  name: 'ChargePopup',
  components: {
    Popup,
    HighlightText,
    ColumnCarousel,
  },
  props: {
    showChargePopup: {
      type: Boolean,
      default: false,
    },
    mobileCharge: {
      type: Object,
      default: () => {},
    },
    mobileChargeCoupon: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mobileCoupon: {},
      mobileStatus: '',
      isProcessing: false, // 添加处理状态
      normalDescStyle: {
        fontSize: '0.12rem',
        color: '#a8a8a8',
      },
      highlightDescStyle: {
        fontSize: '0.12rem',
        color: '#a54d08',
      },
      normalMarqueeStyle: {
        fontWeight: 400,
        fontSize: '0.12rem',
        lineHeight: '0.17rem',
        letterSpacing: '0rem',
        textAlign: 'center',
        color: '#4d1b00',
      },
      highlightMarqueeStyles: {
        bold: {
          fontWeight: 600,
          fontSize: '0.12rem',
          lineHeight: '100%',
          letterSpacing: '0rem',
          textAlign: 'center',
          color: '#4d1b00',
        },
        red: {
          color: '#FF2A41',
          fontSize: '0.12rem',
          fontWeight: 600,
          lineHeight: 'normal',
        },
      },
    };
  },
  computed: {
    chargeBtnText() {
      if (this.mobileStatus === COUPON_STATUS.receive) {
        return '领券并前往充话费';
      }
      return '去充话费';
    },
    archiveMobileCoupon() {
      if (this.mobileStatus === COUPON_STATUS.achieve) {
        return true;
      }
      return false;
    },
    bonusSumText() {
      const { usedRewardDeduction, rewardDeductionSum } = this.mobileCharge;
      if (usedRewardDeduction === 0) return '';

      if (usedRewardDeduction >= rewardDeductionSum) {
        return '已用完';
      }
      return `已用${usedRewardDeduction}/${rewardDeductionSum}`;
    },
    shouldShowMobileCharge() {
      return this.mobileCharge
          && Object.keys(this.mobileCharge).length > 0
          && this.mobileChargeCoupon
          && Object.keys(this.mobileChargeCoupon).length > 0;
    },
  },
  watch: {
    mobileChargeCoupon: {
      handler() {
        this.updateData();
      },
      deep: true,
    },
  },
  mounted() {
    this.updateData();
  },
  methods: {
    updateData() {
      this.mobileCoupon = safeGet(this, 'mobileChargeCoupon', {});
      const { status } = this.mobileCoupon;
      this.mobileStatus = status;
    },
    handleClose() {
      this.$emit('close');
    },
    handleCharge() {
      // 防止重复处理
      if (this.isProcessing) {
        return;
      }

      const chargeUrl = this.mobileCharge.redirectUrl;
      this.isProcessing = true;
      if (this.mobileStatus === COUPON_STATUS.receive) {
        this.$emit('click-btn',
          {
            ...this.mobileCoupon,
            closeRedPacket: true,
          });
        setTimeout(() => {
          Navigator.go(chargeUrl);
          this.$emit('close');
          this.isProcessing = false; // 重置处理状态
        }, 2000);
      } else {
        Navigator.go(chargeUrl);
        this.$emit('close');
        this.isProcessing = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.charge-popup-container {
  background: linear-gradient(178.01deg, #fbf1e0 16.73%, #fff 66.86%);
  border-radius: 0.22rem 0.22rem 0 0;
  font-weight: normal;
  border-top: 0.02rem solid #fff;

  .charge-popup-header {
    display: flex;
    align-items: center;
    padding: 0.18rem 0 0 0.1rem;
    margin-bottom: 0.1rem;
    position: relative;

    .charge-popup-title {
      height: 0.35rem;
      width: auto;
      margin: 0 auto;
    }

    .close-icon {
      position: absolute;
      top: 0.02rem;
      right: 0.1rem;
      height: 0.23rem;
      width: 0.23rem;
    }
  }

  .charge-popup-content {
    background-color: #fff;
    border-radius: 0.22rem;
    margin: 0 0.1rem;
    padding: 0.18rem 0.35rem 0.52rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .marquee {
      height: 0.17rem;
      width: 101%;

      .marquee-text {
        line-height: 0.17rem;
      }
    }

    .rolling-text {
      height: 0.17rem;
    }

    .coupon-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.16rem;
      margin-top: 0.18rem;
      position: relative;

      .left-charge-coupon,
      .right-bonus-coupon {
        width: 1.35rem;
        height: 1.62rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .left-charge-title,
      .right-bonus-title {
        margin-top: 0.07rem;
        font-weight: 600;
        font-size: 0.16rem;
      }

      .left-charge-price,
      .right-bonus-price {
        height: 0.47rem;
        line-height: 0.47rem;
        margin-top: 0.07rem;
        font-size: 0.4rem;
        color: #fff;
        font-family: "DINAlternate", sans-serif;
        font-weight: bold;

        &::before {
          content: '¥';
          font-size: 0.22rem;
        }
      }

      .right-bonus-price {
        margin-top: 0.04rem;
        color: #000;
      }

      .left-charge-coupon {
        background-image: url('https://m.hellobike.com/c24ed9a7d1.png');
        background-size: 100% 100%;
        color: #fff;
        position: relative;

        .left-charge-rules {
          font-size: 0.12rem;
          opacity: 0.7;
        }

        .left-charge-isUsed-icon {
          position: absolute;
          top: 0.05rem;
          right: 0;
          width: auto;
          height: 0.93rem;
        }

        &.isUsed {
          opacity: 0.5;
        }
      }

      .middle-plus-icon {
        position: absolute;
        top: 0.94rem;
        left: 1.28rem;
        height: 0.3rem;
        width: 0.3rem;
      }

      .right-bonus-coupon {
        background-image: url('https://m.hellobike.com/3d60a1feda.png');
        background-size: 100% 100%;

        .right-bonus-rules {
          width: 0.72rem;
          height: 0.34rem;
          text-align: center;
          font-size: 0.12rem;
          opacity: 0.5;
        }

        .bonusSum {
          width: 1.22rem;
          height: 0.29rem;
          margin: 0.13rem 0 0.05rem 0;
          border-radius: 0.145rem;
          background: rgba(255, 255, 255, 0.7);

          .bonusSum-text {
            font-weight: 400;
            font-size: 0.12rem;
            line-height: 0.29rem;
            color: #000;
            text-align: center;
            opacity: 0.5;
          }
        }
      }
    }

    .charge-popup-btn {
      width: 2.46rem;
      height: 0.42rem;
      line-height: 0.42rem;
      border-radius: 0.24rem;
      margin-top: 0.32rem;
      border: 0.01rem solid linear-gradient(180deg, #ff1e1e 0%, #ff5454 100%);
      background:
        linear-gradient(
          101.31deg,
          #ff744e 8.18%,
          #ff3b3f 38.64%,
          #ff3b3f 69.09%,
          #ff4ea7 89.73%
        );
      text-align: center;
      color: #fff;
      font-weight: 500;
      font-size: 0.16rem;
    }

    .charge-desc-text {
      margin-top: 0.15rem;
    }
  }
}
</style>
